// this helper groups the rights by category
export const getGroupedRightsList = rightsList =>
  rightsList.reduce((acc, right) => {
    // Copy the right and category objects to avoid mutating the original data
    const copiedRight = { ...right }
    let copiedCategory = { ...right.category }

    // If the category is null, assign it to a special category "Other"
    if (!copiedCategory.id) {
      copiedCategory = { id: 'other', name: 'Other' }
    }

    // If the category id is not in the accumulator, add it with an empty array
    if (!acc[copiedCategory.id]) {
      acc[copiedCategory.id] = {
        category: copiedCategory,
        rights: []
      }
    }

    // Push the right into the corresponding category array
    acc[copiedCategory.id].rights.push(copiedRight)

    return acc
  }, {})
